import cleanedFilename from '~/util/cleanedFilename';

export default {
  PRIMITIVE_INPUT: `${cleanedFilename(__filename)}-input`,
};
